export const REVALIDATION_SECONDS = 10 * 60 // 10 minutes
export const NEXTJS_FETCH_OPTIONS = {
  fetchOptions: {
    next: { revalidate: REVALIDATION_SECONDS },
  },
}
